import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {UserAuthContextProvider} from "./context/AuthContext";
import {BrowserRouter} from "react-router-dom";
import enUS from "antd/es/locale/en_US";
import {ConfigProvider} from "antd";
import GlobalStateProvider from "./context/GlobalContext";
import {PageLoading} from "@ant-design/pro-layout";
// import 'antd/dist/reset.css';


ReactDOM.render(
    <React.StrictMode>
        {/*<WinstonProvider logger={logger}>*/}
        {/*<QueryClientProvider client={queryClient as any}>*/}
        <GlobalStateProvider>
            <UserAuthContextProvider>
                <ConfigProvider locale={enUS}>
                    <BrowserRouter>
                        <Suspense fallback={<PageLoading/>}>
                            <App/>
                        </Suspense>
                    </BrowserRouter>
                </ConfigProvider>
            </UserAuthContextProvider>
        </GlobalStateProvider>
        {/*</WinstonProvider>*/}
        {/*<ReactQueryDevtools />*/}

        {/*</QueryClientProvider>*/}

    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
